// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "app-" + chunkId + "." + {"679":"333f7e6e00a44a55f132","936":"113ce8c2c6c94e04ae90"}[chunkId] + ".js";
};